import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import { Control, Controller } from 'react-hook-form';
import { ResourcesFormData } from './DeployResourcesModal';

interface FileUploadProps {
	onFileUpload: (file: File) => void;
	accept: {
		[key: string]: string[];
	};
	control: Control<ResourcesFormData>;
	onRejection?: (rejectedFiles: FileRejection[]) => void;
	onError?: (e: Error) => void;
	disabled?: boolean;
}

const DropzoneFileUploadField = (props: FileUploadProps) => {
	const { onFileUpload, accept, control, onRejection, onError, disabled } =
		props;

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop: (files) => onFileUpload(files[0]),
		multiple: false,
		accept: accept,
		onError: onError,
		onDropRejected: onRejection,
		disabled: disabled,
	});

	return (
		<Controller
			control={control}
			name={'file'}
			render={({ field, fieldState: { error } }) => {
				return (
					<FormControl error={!!error} variant='standard'>
						<Box
							{...getRootProps()}
							sx={{
								border: '2px dashed',
								borderColor: grey[400],
								borderRadius: '4px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center',
								height: '150px',
								cursor: 'pointer',
								outline: 'none',
								transition: 'border .24s ease-in-out',
								backgroundColor: isDragActive ? '#f0f0f0' : 'white',
							}}
						>
							<input {...getInputProps()} />
							{isDragActive ? (
								<Typography variant='h6'>Drop the file here...</Typography>
							) : (
								<>
									<CloudUploadIcon fontSize='large' color='secondary' />
									<Typography variant='h6'>
										Drag &amp; drop or click to upload
									</Typography>
								</>
							)}
						</Box>
						{!!error && error.message && (
							<FormHelperText sx={{ ml: '14px', mr: '14px' }}>
								{error.message}
							</FormHelperText>
						)}
						{field.value && field?.value?.name && (
							<Typography
								variant='caption'
								sx={{
									display: 'flex',
									alignItems: 'center',
									mt: 2,
								}}
							>
								<FilePresentIcon />
								<Box
									sx={{
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
								>
									{field.value.name}
								</Box>
							</Typography>
						)}
					</FormControl>
				);
			}}
		/>
	);
};

export default DropzoneFileUploadField;
